import React, { useEffect, useState } from 'react';
import { Tag, TagType } from '../../types/tag';
import { tagService } from '../../services/tagService';

interface HardTagSelectProps {
    type: TagType;
    selectedTags: string[]; // Array of Tag IDs
    onChange: (selectedIds: string[]) => void;
    multi?: boolean;
    label?: string;
}

export const HardTagSelect: React.FC<HardTagSelectProps> = ({
    type,
    selectedTags,
    onChange,
    multi = true,
    label
}) => {
    const [availableTags, setAvailableTags] = useState<Tag[]>([]);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        const fetchTags = async () => {
            setLoading(true);
            try {
                const tags = await tagService.getTagsByType(type);
                setAvailableTags(tags);
            } catch (error) {
                console.error('Failed to fetch tags', error);
            } finally {
                setLoading(false);
            }
        };
        fetchTags();
    }, [type]);

    const handleToggle = (tagId: string) => {
        if (multi) {
            if (selectedTags.includes(tagId)) {
                onChange(selectedTags.filter(id => id !== tagId));
            } else {
                onChange([...selectedTags, tagId]);
            }
        } else {
            // Single select: toggle off if same clicked, or switch to new
            if (selectedTags.includes(tagId)) {
                onChange([]);
            } else {
                onChange([tagId]);
            }
        }
    };

    if (loading) {
        return <div className="animate-pulse h-8 bg-slate-100 rounded w-full"></div>;
    }

    return (
        <div className="space-y-2">
            {label && <label className="text-sm font-medium text-slate-700">{label}</label>}
            <div className="flex flex-wrap gap-2">
                {availableTags.map(tag => {
                    const isSelected = selectedTags.includes(tag.name);
                    return (
                        <button
                            key={tag.id}
                            type="button"
                            onClick={() => handleToggle(tag.name)}
                            className={`
                px-3 py-1.5 rounded-full text-sm font-medium transition-all duration-200 border
                ${isSelected
                                    ? 'bg-blue-600 text-white border-blue-600 shadow-sm'
                                    : 'bg-white text-slate-600 border-slate-200 hover:border-slate-300 hover:bg-slate-50'
                                }
              `}
                            aria-pressed={isSelected}
                        >
                            {tag.name}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};
